/**
 * Gets the appropriate action links based on the error step
 * @param step - The error step number
 * @returns Object containing primary and secondary action links
 */
export const getActionLinks = (step: number) => {
  switch (step) {
    case 1:
      return {
        primary: "Retry Generation",
        secondary: "Contact Support",
      };
    case 2:
      return {
        primary: "Resend",
        secondary: "Call Customer",
      };
    case 3:
      return {
        primary: "Resend Enrollment Form",
        secondary: "Contact Support",
      };
    case 4:
      return {
        primary: "Check Status",
        secondary: "",
      };
    default:
      return {
        primary: "Retry Generation",
        secondary: "Contact Support",
      };
  }
};
